import React, { useState } from 'react';
import { Box, Paper, List, ListItemButton, ListItemIcon, ListItemText, Typography, Divider } from '@mui/material';

// Icons
import PaymentIcon from '@mui/icons-material/Payment';
import BlockIcon from '@mui/icons-material/Block';
import AssessmentIcon from '@mui/icons-material/Assessment';
import TableChartIcon from '@mui/icons-material/TableChart';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import CategoryIcon from '@mui/icons-material/Category';
import AssignmentIcon from '@mui/icons-material/Assignment';

// Import child components
import GeneratePayroll from './GeneratePayroll';
import HoldSalaryManagement from './HoldSalaryManagement';
import HoldSalaryReport from './HoldSalaryReport';
import DataSheetReport from './DataSheetReport';
import ComponentMaster from './ComponentMaster';
import AssignComponents from './AssignComponents';
import PayslipManagement from './PayslipManagement'; // NEW IMPORT

const PayrollDashboard = () => {
  const [activeMenu, setActiveMenu] = useState('generate');

  const NavItem = ({ id, label, icon }) => (
    <ListItemButton 
      selected={activeMenu === id} 
      onClick={() => setActiveMenu(id)}
      sx={{
        borderRadius: '8px', 
        mx: 1,
        mb: 0.5,
        '&.Mui-selected': { 
          bgcolor: 'primary.main', 
          color: 'white', 
          '&:hover': { bgcolor: 'primary.dark' } 
        },
        '&.Mui-selected .MuiListItemIcon-root': { 
          color: 'white' 
        }
      }}
    >
      <ListItemIcon sx={{ minWidth: 40, color: activeMenu === id ? 'white' : 'inherit' }}>
        {icon}
      </ListItemIcon>
      <ListItemText 
        primary={label} 
        primaryTypographyProps={{ fontWeight: activeMenu === id ? 'bold' : 'medium', fontSize: '0.85rem' }} 
      />
    </ListItemButton>
  );

  return (
    <Paper elevation={3} sx={{ 
      display: 'flex', 
      height: '85vh', 
      mt: 1, 
      width: '100%', 
      borderRadius: 3, 
      overflow: 'hidden' 
    }}>
      
      {/* LEFT PANE - Independent Scroll */}
      <Box sx={{ 
        width: 230, 
        borderRight: 1, 
        borderColor: 'divider', 
        bgcolor: '#ffffff', 
        pt: 2, 
        boxShadow: '2px 0 5px rgba(0,0,0,0.05)', 
        zIndex: 1, 
        flexShrink: 0,
        overflowY: 'auto' 
      }}>
        <List component="nav" dense>
          <Typography variant="caption" sx={{ px: 2, fontWeight: 'bold', color: 'text.secondary', display: 'block', mb: 1 }}>
            CORE OPERATIONS
          </Typography>
          <NavItem id="generate" label="Generate Payroll" icon={<PaymentIcon fontSize="small" />} />
          <NavItem id="hold_salary" label="Hold Salary" icon={<BlockIcon fontSize="small" />} />
          <NavItem id="hold_salary_report" label="Hold Salary Report" icon={<AssessmentIcon fontSize="small" />} />
          <NavItem id="datasheets" label="DataSheets" icon={<TableChartIcon fontSize="small" />} />
          <NavItem id="payslips" label="Payslips" icon={<ReceiptLongIcon fontSize="small" />} />
          
          <Divider sx={{ my: 2 }} />

          {/* SECTION: Additions & Deductions Configuration */}
          <Typography variant="caption" sx={{ px: 2, fontWeight: 'bold', color: 'text.secondary', display: 'block', mb: 1 }}>
            PAYROLL COMPONENTS
          </Typography>
          <NavItem id="master_components" label="Component Master" icon={<CategoryIcon fontSize="small" />} />
          <NavItem id="assign_components" label="Assign Components" icon={<AssignmentIcon fontSize="small" />} />

          <Divider sx={{ my: 2 }} />

          <Typography variant="caption" sx={{ px: 2, fontWeight: 'bold', color: 'text.secondary', display: 'block', mb: 1 }}>
            SETTINGS
          </Typography>
          <NavItem id="settings" label="Configuration" icon={<SettingsSuggestIcon fontSize="small" />} />
        </List>
      </Box>

      {/* RIGHT PANE - Top-Left Aligned */}
      <Box sx={{ 
        flexGrow: 1, 
        p: 4, 
        width: '100%', 
        bgcolor: '#fbfbfb', 
        overflowY: 'auto', 
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start', 
        textAlign: 'left'
      }}>
        <Box sx={{ width: '100%', maxWidth: 1100 }}>
          {activeMenu === 'generate' && <GeneratePayroll />}
          {activeMenu === 'hold_salary' && <HoldSalaryManagement />}
          {activeMenu === 'hold_salary_report' && <HoldSalaryReport />}
          {activeMenu === 'datasheets' && <DataSheetReport />}
          
          {/* NEW: Render the Payslip Management UI */}
          {activeMenu === 'payslips' && <PayslipManagement />}

          {activeMenu === 'master_components' && <ComponentMaster />}
          {activeMenu === 'assign_components' && <AssignComponents />}

          {activeMenu === 'settings' && (
            <Box sx={{ color: 'text.secondary', mt: 2 }}>
              <Typography variant="h6">Payroll Configuration</Typography>
              <Typography variant="body2">Phase 5 Feature...</Typography>
            </Box>
          )}
        </Box>
      </Box>

    </Paper>
  );
};

export default PayrollDashboard;